import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const ImportsApi = {
  index(query) {
    return http.get(`${teamPath()}/imports`, { params: query }).then((response) => response.data);
  },

  store(data) {
    return http.post(`${teamPath()}/imports`, data).then((response) => response.data.data);
  },

  show(id) {
    return http.get(`${teamPath()}/imports/${id}`).then((response) => response.data.data);
  },

  process(id) {
    return http.post(`${teamPath()}/imports/${id}`).then((response) => response.data.data);
  },

  destroy(id) {
    return http.delete(`${teamPath()}/imports/${id}`).then((response) => response.data.data);
  },

  result(id) {
    let query = { json: 1 };
    return http.get(`${teamPath()}/imports/${id}/result`, { params: query }).then((response) => {
      if (!Array.isArray(response?.data)) {
        return response.data;
      }

      // Transform the data array to replace "Value"
      // in the message with actual value in quotes
      return response.data.map((item) => ({
        ...item,
        message: item.message.replace(/Value/g, `"${item.value}"`),
      }));
    });
  },
};
